<script setup lang="ts">
// Share Popover Component
</script>

<template>
  <div class="share-popover-mock dark animate-in">
     <!-- Desktop View -->
     <div class="desktop-share-ui hide-mobile">
        <div class="popover-header dark">Share Bet</div>
        <div class="popover-social-icons dark">
           <div class="p-icon wa"><i class="pi pi-whatsapp"></i></div>
           <div class="p-icon tg"><i class="pi pi-telegram"></i></div>
           <div class="p-icon x"><i class="pi pi-twitter"></i></div>
           <div class="p-icon fb"><i class="pi pi-facebook"></i></div>
           <div class="p-icon more"><i class="pi pi-qrcode"></i></div>
        </div>
        <div class="popover-link-box dark">
           <span class="link-text">betpic.com/share/composer/</span>
           <i class="pi pi-copy copy-icon"></i>
        </div>
     </div>

     <!-- Mobile iOS Native Share Simulation -->
     <div class="mobile-ios-share-ui hide-desktop">
        <div class="ios-grabber"></div>
        <div class="ios-header">
           <div class="ios-app-icon">
              <img src="@/assets/logo-brand.svg" alt="App" />
           </div>
           <div class="ios-app-info">
              <span class="ios-app-name">BetPic</span>
              <span class="ios-page-url">betpic.com</span>
           </div>
        </div>

        <div class="ios-apps-row">
           <div class="ios-app-item">
              <div class="ios-icon wa"><i class="pi pi-whatsapp" style="font-size: 1.5rem"></i></div>
              <span>WhatsApp</span>
           </div>
           <div class="ios-app-item">
              <div class="ios-icon ig"><i class="pi pi-instagram" style="font-size: 1.5rem"></i></div>
              <span>Instagram</span>
           </div>
           <div class="ios-app-item">
              <div class="ios-icon tg"><i class="pi pi-send" style="font-size: 1.5rem"></i></div>
              <span>Telegram</span>
           </div>
           <div class="ios-app-item">
              <div class="ios-icon fb"><i class="pi pi-facebook" style="font-size: 1.5rem"></i></div>
              <span>Facebook</span>
           </div>
           <div class="ios-app-item">
              <div class="ios-icon more"><i class="pi pi-ellipsis-h" style="font-size: 1.5rem"></i></div>
              <span>More</span>
           </div>
        </div>

        <div class="ios-actions-list">
           <div class="ios-action-item">
              <span>Copy</span>
              <i class="pi pi-copy"></i>
           </div>
           <div class="ios-action-item">
              <span>Share...</span>
              <i class="pi pi-share-alt"></i>
           </div>
           <div class="ios-action-item">
              <span>Save to Files</span>
              <i class="pi pi-folder"></i>
           </div>
        </div>
     </div>
  </div>
</template>

<style scoped>
@import 'primeicons/primeicons.css';
.share-popover-mock { position: absolute; bottom: 80px; right: 0; width: 320px; background: #18181b; border-radius: 16px; border: 1px solid #27272a; padding: 20px; box-shadow: 0 20px 50px rgba(0,0,0,0.5); z-index: 100; }

/* Desktop UI */
.popover-header { font-weight: 800; color: #fff; margin-bottom: 16px; }
.popover-social-icons { display: flex; gap: 10px; margin-bottom: 20px; }
.p-icon { width: 40px; height: 40px; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: #fff; }
.p-icon.wa { background: #22c55e; }
.p-icon.tg { background: #0088cc; }
.p-icon.x { background: #1a1a1a; }
.p-icon.fb { background: #006AFF; }
.p-icon.more { background: #555; }
.popover-link-box { background: #000; border-radius: 100px; padding: 12px 20px; display: flex; justify-content: space-between; align-items: center; gap: 10px; border: 1px solid #27272a; }
.link-text { font-size: 0.75rem; color: #a1a1aa; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.copy-icon { color: #a1a1aa; cursor: pointer; }

/* iOS Mobile UI */
.mobile-ios-share-ui { padding: 8px 16px 40px; color: #fff; }
.ios-grabber { width: 36px; height: 5px; background: rgba(255,255,255,0.2); border-radius: 100px; margin: 0 auto 20px; }
.ios-header { display: flex; align-items: center; gap: 12px; margin-bottom: 24px; background: rgba(255,255,255,0.05); padding: 12px; border-radius: 12px; }
.ios-app-icon { width: 40px; height: 40px; background: #000; border-radius: 8px; overflow: hidden; display: flex; align-items: center; justify-content: center; border: 1px solid rgba(255,255,255,0.1); }
.ios-app-icon img { height: 24px; width: auto; }
.ios-app-info { display: flex; flex-direction: column; }
.ios-app-name { font-weight: 700; font-size: 0.95rem; }
.ios-page-url { font-size: 0.75rem; color: #a1a1aa; }

.ios-apps-row { display: flex; gap: 20px; overflow-x: auto; padding-bottom: 20px; margin-bottom: 20px; border-bottom: 1px solid rgba(255,255,255,0.1); -webkit-overflow-scrolling: touch; }
.ios-apps-row::-webkit-scrollbar { display: none; }
.ios-app-item { display: flex; flex-direction: column; align-items: center; gap: 8px; min-width: 60px; }
.ios-app-item span { font-size: 0.7rem; color: #fff; text-align: center; }
.ios-icon { width: 56px; height: 56px; border-radius: 14px; display: flex; align-items: center; justify-content: center; color: #fff; }
.ios-icon.wa { background: #22c55e; }
.ios-icon.ig { background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%); }
.ios-icon.tg { background: #0088cc; }
.ios-icon.fb { background: #006AFF; }
.ios-icon.more { background: #27272a; }

.ios-actions-list { background: rgba(255,255,255,0.08); border-radius: 12px; overflow: hidden; }
.ios-action-item { padding: 14px 16px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid rgba(255,255,255,0.05); color: #fff; font-size: 0.95rem; font-weight: 500; }
.ios-action-item:last-child { border-bottom: none; }

@media (max-width: 768px) {
  .share-popover-mock { 
    position: fixed; 
    bottom: 0; 
    left: 0; 
    right: 0; 
    width: 100%; 
    border-radius: 20px 20px 0 0; 
    border: none;
    background: rgba(28, 28, 30, 0.85);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    padding: 10px 0 0;
    box-shadow: 0 -10px 40px rgba(0,0,0,0.4);
    animation: slideUp 0.4s cubic-bezier(0.3, 0.85, 0.3, 1) forwards;
  }
  .hide-mobile { display: none !important; }
}

@media (min-width: 769px) {
  .hide-desktop { display: none !important; }
}

@keyframes slideUp { 
  from { transform: translateY(100%); } 
  to { transform: translateY(0); } 
}

.animate-in { animation: fadeInUp 0.4s ease forwards; }
@keyframes fadeInUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>
